import { LinearProgress, styled } from '@mui/material';

export const ProgressBar = styled(LinearProgress)(() => ({
  width: '70%',
}));
